import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState } from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import BaseTextareaAutosize from '@mui/material/TextareaAutosize';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import HeaderMMS from '../header/header';
import MenuMMS from '../menu/menu';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import RichTextEditor from "../RichTextEditor";


export default function Settings() {
    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
  
    const handleClose = () => {
      setOpenDialog(false);
    };
    const handleDrawerOpen = () => {
      setOpen(true);
    };
   
  const headerProps={
    open,handleDrawerOpen
  }
  const menuProps={
    setOpen,open
  }
  const tableProps={
    setOpenDialog
  }
  const handleDateChange = (date, field) => {
    setFormData({
      ...formData,
      [field]: date
    });
  };
  const [formData, setFormData] = useState({
    slno: '',
    dateofpurchase: null,
    make: '',
    poNumber: '',
    invoiceNumber: '',
    date: '',
    warrentystart: '',
    warrentyend: '',
    warrentyPeriod: '',
    expiryNotification: '',
    vendorSupplier: '',
    contactName: '',
    contactNumber: '',
    contactEmail: '',
    dateinvoicenum: null,
    dateinvoice: null
  });
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };
  const Textarea = styled(BaseTextareaAutosize)(
    ({ theme }) => `
    box-sizing: border-box;
   
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

   
  `,
  );
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));
    return (
        <Box sx={{ display: 'flex' }}>
      
        <HeaderMMS {...headerProps} />
        <MenuMMS {...menuProps} />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }} className='bg-slate-100'>
        <Grid className='bg-slate-100 '>
        <DrawerHeader />
        {/* <Forms /> */}


<div >

        
      
    </div>

        <div className='text-left bg-white  m-2 border-solid border rounded'>
            <div className='border-slate-300 rounded-md  '>
              <h3 className='border-b-2  p-3 bg-gray-200 '>Near MISS</h3>
            </div>
            <div className='grid grid-cols-1 gap-4 md:grid-cols-3  p-3 mms-date-field'>
              
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date and Time"
                    value={formData.dateinvoice}
                    onChange={(date) => handleDateChange(date, 'dateinvoice')}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>

              <TextField size='small' label="Location" variant="outlined" name="StatutoryCompliance" />
              <TextField sx={{ width: '100%' }} multiline rows={3} label="Near Miss Description" />
               <RichTextEditor />
              <TextField sx={{ width: '100%' }} multiline rows={3} label="Witness if any" />
              <FormControl >
                <InputLabel id="planFacility">Near Miss Category</InputLabel>
                <Select className='mms-select'
                  name="planFacility"
                  
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={10}>Lifting Tools and Tackles</MenuItem>
                  <MenuItem value={20}>Contract Labour</MenuItem>
                  <MenuItem value={30}>PESO Licence</MenuItem>
                  <MenuItem value={40}>Environment (MoEF / CRZ / TNPCB)</MenuItem>
                  <MenuItem value={50}>Electrical Installations</MenuItem>
                  <MenuItem value={60}>Equipements Testing & Calibration</MenuItem>
                  <MenuItem value={70}>Weights & Measures</MenuItem>
                  <MenuItem value={80}>ROW</MenuItem>
                </Select>
              </FormControl>

              <TextField size='small' label="Person Involved" variant="outlined" name="StatutoryCompliance" />
              <TextField sx={{ width: '100%' }} multiline rows={3} label="description of potential consequences" />
              <TextField sx={{ width: '100%' }} multiline rows={3} label="Action Taken" />
              <FormControl >
                <InputLabel id="planFacility">Contributing Factor</InputLabel>
                <Select className='mms-select'
                  name="planFacility"   
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={10}>Once in a year</MenuItem>
                  <MenuItem value={20}>Once in 3 years</MenuItem>
                </Select>
              </FormControl>
              <TextField sx={{ width: '100%' }} multiline rows={3} label="provincial Message" />
              <TextField sx={{ width: '100%' }} multiline rows={3} label="Additional Message" />
              <TextField size='small' label="Reportel Name" variant="outlined" name="StatutoryCompliance" />
              <TextField size='small' label="Job Title / Role" variant="outlined" name="StatutoryCompliance" />
                <TextField sx={{ width: '100%' }} multiline rows={3} label="Contact Details" />
               
            </div>

          </div>
       
        
     
         </Grid>
        </Box>
      </Box>
    );

}